<template>
  <!-- same horizontal padding as v-card-text (px-6) -->
  <v-sheet class="px-6 pt-2 pb-0 d-flex align-center justify-space-between">
    <!-- status chip on the left -->
    <v-chip
      :color="statusColor"
      label
      size="small"
      class="text-body-2 font-weight-medium"
    >
      {{ scrape.uiStatus }}
    </v-chip>
    <!-- action buttons on the right -->
    <div class="d-flex pb-2">
      <!-- Toggle: Pause ▸ Resume -->
      <v-btn
      color="primary"
      :prepend-icon="toggleIcon"
      :disabled="toggleDisabled"
      @click="toggleHandler"
      >
      {{ toggleLabel }}
      </v-btn>

      <div class="mx-1"></div> <!-- Gap between buttons -->

      <!-- Reset is always present -->
      <v-btn
      color="error"
      prepend-icon="mdi-refresh"
      :disabled="scrape.uiStatus === ScrapeUiStatus.READY"
      @click="scrape.reset"
      >
      Reset
      </v-btn>
    </div>
  </v-sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useScrapeControlStore } from '@/store/scrapeControlStore';
import { ScrapeUiStatus } from '@/enums/ScrapeUiStatus';

const scrape = useScrapeControlStore();

/* status-chip colour */
const statusColor = computed(() => {
  switch (scrape.uiStatus) {
    case ScrapeUiStatus.READY:   return 'grey';
    case ScrapeUiStatus.RUNNING: return 'success';
    case ScrapeUiStatus.PAUSED:  return 'warning';
    default:                     return 'grey';
  }
});

/* -------- toggle-button props ------------------------------------ */
const toggleLabel = computed(() =>
  scrape.uiStatus === ScrapeUiStatus.PAUSED ? 'Resume' : 'Pause',
);

const toggleIcon = computed(() =>
  scrape.uiStatus === ScrapeUiStatus.PAUSED ? 'mdi-play' : 'mdi-pause',
);

const toggleDisabled = computed(() => {
  if (scrape.uiStatus === ScrapeUiStatus.READY) return true;     // nothing to pause
  if (scrape.uiStatus === ScrapeUiStatus.PAUSED) return !scrape.allowResume;
  return false; // RUNNING
});

const toggleHandler = () => {
  if (scrape.uiStatus === ScrapeUiStatus.PAUSED) {
    scrape.resume();
  } else if (scrape.uiStatus === ScrapeUiStatus.RUNNING) {
    scrape.pause();
  }
};
</script>

